import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (socket) return socket;

  const token = localStorage.getItem('forgealpha_token');

  const apiUrl = import.meta.env.VITE_API_URL || '';
  socket = io(`${apiUrl}/ws`, {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 50,
  });

  socket.on('connect', () => {
    console.log('[WS] Connected:', socket?.id);
  });

  socket.on('connect_error', (err) => {
    console.warn('[WS] Connect error:', err.message);
  });

  socket.on('disconnect', (reason) => {
    console.warn('[WS] Disconnected:', reason);
  });

  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
